<template>
  <span style="width:100%">
        <label-input
            @focus="searchFocus"
            @blur="searchBlur"
            v-bind="$attrs"
            :disabled="disableInput"
            v-model="form.search"
            v-on="$listeners"
            :label="label"/>
        <span class="close" v-if="clearText" @click="close" ></span>
    <!-- <img v-else src="../images/search-nor.svg" alt=""> -->
    <!-- {{clearText}} -->
    <div class="content" v-if="isShowList && !hideSearchList">
        <template v-if="searchList.length === 0 && form.search">
            <div class="content-no-matches">No Matches</div>
        </template>
        <template v-else>
            <p v-for="(item,index) in searchList" :key="index+Date.now()" v-html="item.label" :id="index === 0 ? 'Enter': null" @click="TextCb(item)">

            </p>
        </template>
    </div>
  </span>
</template>

<script>
import LabelInput from "@/components/label-input-v2/input";

export default {
  components: {LabelInput},
  props: {
    inputWidth: {
      required: false,
      default: ''
    },
    searchData: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    form: {
      type: Object,
      require: true,
      default: function () {
        return {}
      }
    },
    label: {
      type: String,
      require: false,
      default: ''
    },
    hideSearchList: {
      type: Boolean,
      require: false,
      default: false,
    }
  },
  data() {
    return {
      searchList: [],
      isShowList: false,
      loading: false,
      clearText: false,
      disableInput: false
    };
  },
  watch: {
    'form.search': {
      handler(search) {
        if (search) {
          this.clearText = true
          let len = this.searchData.length;
          let arr = [];
          let reg = new RegExp(search.trim(), 'i');
          for (let i = 0; i < len; i++) {
            console.log(this.searchData[i].label.match(reg),'75');
            if (this.searchData[i].label.match(reg)) {
              arr.push({label: this.searchData[i].label, value: this.searchData[i].value, souce: {}});
            }
          }
          this.searchList = arr
          if(this.searchList.length > 0) {
            let replaceString = '<span style="color: #4066d4;">' + search + '</span>'
            this.searchList.forEach((item, index) => {
              let res = item.label.replace(search, replaceString);
              // console.log(res,'86');
              this.$set(this.searchList, index, {
                label: res,
                value: item.value,
                souce: {label: item.label, value: item.value}
              })
              // console.log()
            })
          }else {
            if(search) {
              this.isShowList = true
            }
          }
         
        } else {
          this.clearText = false
          this.searchList = []
        }
      },
      deep: true
    }
  },
  methods: {
    TextCb(item) {
      this.disableInput = true
      this.form.search = item.value
      this.$emit('textCb', item.value);
      setTimeout(() => {
        this.disableInput = false
        this.isShowList = false
      })
    },
    searchFocus() {
      this.isShowList = true;
    },
    searchBlur() {
      setTimeout(() => this.isShowList = false, 200)
    },
    close() {
      this.form.search = '';
      setTimeout(() => {
        this.clearText = false;
        this.searchList = []
        this.$emit('textCb', undefined);
      })
    }
  }
};
</script>

<style lang="scss" scoped>
span {
  position: relative;
  display: inline-block;
}

.el-form-item {
  margin-bottom: 0 !important;
}

.close {
  position: absolute;
  top: 12px;
  right: 12px;
  display: block;
  width: 16px;
  cursor: pointer;
  height: 16px;
  background: url('../../assets/img/common-icon/icon-16-close.svg');
  &:hover {
    background: url('../../assets/img/common-icon/icon-16-close-hover.svg');
  }
}

.content {
    width: 100%;
    max-height: 200px;
    overflow: hidden;
    overflow-y: auto;
    border-radius: 2px;
    margin-top: 4px;
    transition: .5s;
    position: absolute;
    box-shadow: 0 1px 5px 0 rgba(0, 5, 57, 0.2);
    z-index: 10000;
    border-radius: 6px;
    padding: 0 8px;
    background: #fff;
    &-no-matches {
      color: #b2b6c0;
      padding: 18px;
      height: 52px;
      font-weight: 500;
    }
    p {
        font-size: 12px;
        height: 40px;
        width: 100%;
        color: #000;
        line-height: 40px;
        font-weight: 500;
        background: #fff;
        cursor: pointer;
        padding: 0 10px;
        // margin-top: 8px;
    }
    p:first-child{
        margin-top: 10px;
    }
    p:last-child{
        margin-bottom: 10px;
    }

  p:hover {
    border-radius: 4px;
    background-color: #f6f7f9;
  }

  img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    animation: Rotation 1s linear infinite;
    @keyframes Rotation {
      from {
        -webkit-transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(360deg);
      }
    }
  }
}

.none {
  height: 0;
  transition: .5s;
}
</style>
